import { render, staticRenderFns } from "./AwardMortgageBusinessCard.vue?vue&type=template&id=54744ac6&scoped=true&"
import script from "./AwardMortgageBusinessCard.vue?vue&type=script&lang=js&"
export * from "./AwardMortgageBusinessCard.vue?vue&type=script&lang=js&"
import style0 from "./AwardMortgageBusinessCard.vue?vue&type=style&index=0&id=54744ac6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54744ac6",
  null
  
)

export default component.exports